import styled, { css } from "styled-components";
import COLORS from "scss/colors.module.scss";

const StyledToolbarButton = styled.div`
  margin: 3px;
  border-radius: 4px;
  cursor: pointer;
  padding: 5px;
  &:hover {
    background-color: ${COLORS.ACTIONS_HOVER};
  }
  ${(props) =>
    props.highlighted &&
    css`
      background-color: ${COLORS.GROUPED_FIELDS} !important;
      &:hover {
        box-shadow: inset 0px 0px 0px 2px ${COLORS.GROUPED_FIELDS_HOVER};
        box-sizing: border-box;
      }
    `};
  && {
    svg {
      color: #000;
    }
  }
  ${(props) =>
    // props.screenWidth <= 1401 &&
    // props.highlighted &&
    props.isMaxWidth &&
    css`
      max-width: 100px;
    `};
`;

export const StyledToolbarTitle = styled.div`
  color: #000;
  font-size: 12px;
  font-weight: 500;
  padding: 2px;
  padding-left: 5px;
  ${(props) =>
    // props.screenWidth <= 1401 &&
    props.isMaxWidth &&
    css`
      display: inline-block;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    `}
`;

export default StyledToolbarButton;
